export default __webpack_public_path__ + "static/media/(6)-Chocolate-sin-azucar.59c5c81e.jpg";